// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarAddComment-cls1_OFv","cls2":"SidebarAddComment-cls2_okP SidebarAddComment-cls1_OFv"};